/**
 * Self-hosted Stitch-style imagery under /public/images/stitch/.
 * Replace .svg with .png exports of the same basename if you add high-res mockups.
 */
export const STITCH_IMAGES = {
  hormuzHero: {
    src: '/images/stitch/hormuz-hero-aida.jpg',
    alt: 'Aerial view of the Strait of Hormuz and Persian Gulf shipping corridor at dusk',
  },
  dashboardHormuzMap: {
    src: '/images/stitch/dashboard-hormuz-map.svg',
    alt: 'Abstract map graphic of the Middle East and Hormuz region for dashboard context',
  },
  insightsFeatured: {
    src: '/images/stitch/insights-featured.svg',
    alt: 'Stylized port and trade infrastructure illustration for the featured insights brief',
  },
  dashboardWorldMap: {
    src: '/images/stitch/dashboard-world-map.svg',
    alt: 'Minimal world map graphic behind GTI leaderboard context',
  },
};
